




































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import User from "@/services/User";
import { userModule } from "@/store/modules/user";

@Component
export default class AnnouncementModal extends Vue {
  @Prop({ required: true }) readonly value;
  @Prop({ required: true }) readonly items = [];

  isShowUpdateNewsModal = false;
  isUpdateNewsConfirmed = false;
  updateNews = [];

  @Watch("isShowUpdateNewsModal")
  changedIsShowUpdateNewsModal(val) {
    if (!val) {
      if (this.isUpdateNewsConfirmed) {
        this.confirmUpdateNews();
      }
    }

    this.$emit("input", val);
  }

  @Watch("value")
  changedValue(val) {
    this.isShowUpdateNewsModal = val;
  }

  confirmUpdateNews() {
    User.setAnnouncementConfirmed(
      userModule.user?.id,
      this.items.map(item => item.id)
    );
  }
}
